<template>
  <div>
    <v-row justify="start">
      <v-col cols="12" sm="6" md="3" class="ml-3">
        <v-autocomplete
          id="fornecedor-autocomplete-grupo-fornecedor"
          class="custom-autocomplete"
          v-model="gruposFornecedores"
          :items="listaGruposFornecedor"
          :label="`${$tc('label.grupo_fornecedor', 1)}`"
          item-value="id"
          item-text="text"
          clearable
          multiple
          chips
          deletable-chips
          @click:append="() => triggerSelecao('fornecedor-autocomplete-grupo-fornecedor')"
          @click.native="(i) => buscaAutocomplete(i, buscarGruposFornecedores)"
          :search-input.sync="triggerGrupoFornecedor"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3" align-self="center" v-show="canEdit && selected.length > 0">
        <v-row>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn text icon id="btn_ativar_inativar" class="mx-0" v-on="on" @click="validarGrupoFornecedorPossuiFluxoAberto()">
                <v-icon>block</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.ativar_inativa') }}</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-data-table
      id="tabela_listaRepresentacaoConjunto"
      v-model="selected"
      :headers="headers"
      :items="listaRepresentacaoConjunto"
      :options.sync="pagination"
      show-select
      :server-items-length="totalPage"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
      }"
      >
      <template v-slot:item.acoes="{ item }" v-if="canEdit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="mx-0" v-on="on" @click.stop="editarItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('label.editar') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.nom_grupo_fornecedor="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.cod_nom_grupo_fornecedor}}
        </span>
      </template>
      <template v-slot:item.ind_ativo="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{ item.ind_ativo ? $t('label.sim') : $t('label.nao')}}
        </span>
      </template>
      <template v-slot:item.qtd_grupos_ativos="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.qtd_grupos_ativos}}
        </span>
      </template>
      <template v-slot:item.qtd_grupos_ativos_suspensos="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.qtd_grupos_ativos_suspensos}}
        </span>
      </template>
      <template v-slot:item.usuario_criacao="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.usuario_criacao}}
        </span>
      </template>
      <template v-slot:item.dta_criacao="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.dta_criacao}}
        </span>
      </template>
      <template v-slot:item.usuario_alteracao="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.usuario_alteracao}}
        </span>
      </template>
      <template v-slot:item.dta_alteracao="{ item }">
        <span :class="{ 'row--disabled': !item.ind_ativo }">
          {{item.dta_alteracao}}
        </span>
      </template>
    </v-data-table>

    <modal-rep-conjunto-inativado-fluxo-aberto
       ref="modalRepConjuntoInativadoFluxoAberto"
       @agree="ativarInativar()"
      >
    </modal-rep-conjunto-inativado-fluxo-aberto>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { forceLoading, forceHideLoading } from '@/common/functions/loading';
import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import ModalRepConjuntoInativadoFluxoAberto from './ModalRepConjuntoInativadoFluxoAberto';

export default {
  name: 'RepresentacaoConjuntoListDados',
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      representacaoConjuntoResource: this.$api.representacaoConjunto(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      listaRepresentacaoConjunto: [],
      listaGruposFornecedor: [],
      gruposFornecedores: [],
      representacaoConjuntoSelecionado: {},
      esperar: false,
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      headers: [
        {
          text: '', value: 'acoes', sortable: false, width: '2%', align: 'center',
        },
        { text: this.$tc('label.grupo_fornecedor', 1), value: 'nom_grupo_fornecedor', sortable: true },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true },
        { text: this.$tc('label.grupo_ativo', 2), value: 'qtd_grupos_ativos', sortable: true },
        { text: this.$tc('label.grupo_ativo_suspenso', 2), value: 'qtd_grupos_ativos_suspensos', sortable: true },
        { text: this.$tc('label.criador', 1), value: 'usuario_criacao', sortable: true },
        { text: this.$tc('label.data_criacao', 1), value: 'dta_criacao', sortable: true },
        { text: this.$tc('label.atualizador', 1), value: 'usuario_alteracao', sortable: true },
        { text: this.$tc('label.data_atualizacao', 1), value: 'dta_alteracao', sortable: true },
      ],
      vinculo: null,
      selected: [],
      triggerGrupoFornecedor: null,
    };
  },
  components: {
    ModalRepConjuntoInativadoFluxoAberto,
  },
  computed: {
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    headersDinamico() {
      const headers = Object.assign([], this.headers);
      if (!this.metadadosRepresentacaoConjunto) return headers;

      Object.keys(this.metadadosRepresentacaoConjunto.mapaEntidades).forEach((entidade) => {
        const mapeamentoEntidade = this.metadadosRepresentacaoConjunto.mapaEntidades[entidade];
        if (mapeamentoEntidade.depObrigatoria) {
          headers.push({
            text: mapeamentoEntidade.entidadeEstrangeira,
            value: mapeamentoEntidade.label,
            sortable: false,
          });
        }
      });

      return headers;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    gruposFornecedores() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
    triggerGrupoFornecedor(val) {
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscarGruposFornecedores(val);
      }, 500);
    },
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    buscar() {
      const params = {
        idsGrupoFornecedor: [...this.gruposFornecedores],
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.representacaoConjuntoResource.listarRepresentacaoConjunto(params).then((response) => {
        this.listaRepresentacaoConjunto = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
        this.selected = [];
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    editarItem(item) {
      this.$router.push({ name: 'editarRepresentacaoConjunto', params: { id: item.id } });
    },
    validarGrupoFornecedorPossuiFluxoAberto() {
      forceLoading();

      const params = {
        idsGrupoFornecedor: this.selected.map((item) => item.id_grupo_fornecedor),
      };

      this.representacaoConjuntoResource.buscarGrupoFornecedorPossuiFluxoAberto(params)
        .then((resultado) => {
          if (resultado.bodyText) {
            forceHideLoading();
            this.$refs.modalRepConjuntoInativadoFluxoAberto.open(resultado.bodyText);
          } else {
            this.ativarInativar();
          }
        }, (err) => {
          forceHideLoading();
          this.$error(this, err);
        });
    },
    ativarInativar() {
      forceLoading();

      const parametros = [];
      const dataAtual = new Date();
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      };
      const horaInativacao = dataAtual.toLocaleString('pt-BR', options);

      this.selected.forEach((item) => {
        parametros.push({
          id: item.id,
          idGrupoFornecedor: item.id_grupo_fornecedor,
          indAtivo: item.ind_ativo,
          indPossuiFluxoEmAberto: item.ind_possui_fluxo_em_aberto,
        });
      });

      this.representacaoConjuntoResource.ativarInativarRepresentacaoConjuntoMassivo(parametros)
        .then(() => {
          const algumItemPossuiFluxoEmAberto = this.selected.filter((rep) => rep.ind_possui_fluxo_em_aberto).length > 0;
          if (algumItemPossuiFluxoEmAberto) {
            this.enviarFluxosEmAbertoParaAnalise(horaInativacao);
          } else {
            this.filtrar();
            forceHideLoading();
            this.$toast(this.$t('message.atualizado_confira_tabela'));
          }
        }, (err) => {
          forceHideLoading();
          this.$error(this, err);
        });
    },
    enviarFluxosEmAbertoParaAnalise(horaInativacao) {
      forceLoading();
      this.selected
        .filter((rep) => rep.ind_possui_fluxo_em_aberto)
        .forEach((item) => {
          const params = {
            idGrupoFornecedor: item.id_grupo_fornecedor,
          };
          let promise = null;
          if (item.ind_ativo) {
            params.justificativa = this.$t('message.enviado_analise_automaticamente_por_inativacao_representacao_conjunto', { horaInativacao });
            promise = this.workflowContratoResource.enviaAnaliseContratoPorInativacaoGrupoRepresentacaoConjunto(params, params);
          } else {
            params.justificativa = this.$t('message.enviado_analise_automaticamente_por_criacao_representacao_conjunto', { horaInativacao });
            promise = this.workflowContratoResource.enviaAnaliseContratoPorCriacaoRepresentacaoConjunto(params, params);
          }
          promise
            .then(() => {
              this.filtrar();
              forceHideLoading();
              this.$toast(this.$t('message.atualizado_confira_tabela'));
            })
            .catch((err) => {
              forceHideLoading();
              this.$error(this, err);
            });
        });
    },
    buscarGruposFornecedores(filtro = null) {
      const params = {
        tamanhoPagina: 100,
        idNivelExtensao: 3,
        nome: filtro,
      };
      return this.extensaoResources.listarExtensoes(params).then((resultado) => {
        resultado.data.resposta.forEach((el) => {
          let nomeGrupoFornecedor = el.id.toString().concat(' - ').concat(el.idExterno);
          if (this.isTenantEpoca) {
            nomeGrupoFornecedor = el.idExterno.toString().concat(' - ').concat(el.nomExtensao);
          }
          const item = { id: el.id, text: nomeGrupoFornecedor };
          this.listaGruposFornecedor.push(item);
        });
      });
    },
  },
  mounted() {
    Promise.all([
      this.filtrar(),
    ]).then();
  },
};
</script>
